<template>
  <div>
    <div class="mb-8 sm:w-1/2">
      <BaseLabel v-bind="form.FirstName" />
      <BaseInput
        v-bind="form.FirstName"
        :validations="$v.form.FirstName"
        @input="setValue(form.FirstName, $event.capitalizeFirstLetter())"
      />
    </div>
    <div class="mb-8 sm:w-1/2">
      <BaseLabel v-bind="form.LastName" />
      <BaseInput
        v-bind="form.LastName"
        :validations="$v.form.LastName"
        @input="setValue(form.LastName, $event.capitalizeFirstLetter())"
      />
    </div>
    <div class="mb-8 sm:w-1/2">
      <BaseLabel v-bind="form.BankName" />
      <BaseInput
        v-bind="form.BankName"
        :validations="$v.form.BankName"
        @input="setValue(form.BankName, $event)"
      />
    </div>
    <div class="mb-8 sm:w-1/2">
      <BaseLabel v-bind="form.AccountNumber" />
      <BaseInput
        v-bind="form.AccountNumber"
        :validations="$v.form.AccountNumber"
        @input="setValue(form.AccountNumber, $event)"
      />
    </div>
    <div class="mb-8 sm:w-1/2">
      <BaseLabel v-bind="form.Swift" />
      <BaseInput
        v-bind="form.Swift"
        :validations="$v.form.Swift"
        @input="setValue(form.Swift, $event.toUpperCase())"
      />
    </div>
    <div class="mb-8 sm:w-1/2">
      <BaseLabel v-bind="form.Iban" />
      <BaseInput
        v-bind="form.Iban"
        :validations="$v.form.Iban"
        @blur="onIbanBlur(form.Iban, $event.replace(/\s/g, '').toUpperCase())"
        @input="onIbanInput(form.Iban, $event.replace(/\s/g, ''))"
      />
    </div>
    <div class="mb-8 sm:w-1/2">
      <BaseLabel v-bind="form.AdditionalBankDetails" />
      <BaseTextarea
        v-bind="form.AdditionalBankDetails"
        :validations="$v.form.AdditionalBankDetails"
        @input="setValue(form.AdditionalBankDetails, $event)"
      />
    </div>
  </div>
</template>

<script>
import formMixin from './shared/form-mixin';

import { http } from '@/store/shared';

import {
  inputText,
  inputAccountNumber,
  textAreaBankDetails,
  inputSwift
} from '@/components/Form/validation/standard-validations';

export default {
  name: 'BankDetails',
  mixins: [formMixin],
  data: () => ({
    validations: {
      FirstName: inputText,
      LastName: inputText,
      BankName: inputText,
      AccountNumber: inputAccountNumber,
      Swift: inputSwift,
      Iban: {
        async iban(value) {
          if (value === '') return true;

          const {
            data: {
              result: { isValid }
            }
          } = await http.get(`/validate/iban/${value}`);

          return await isValid;
        }
      },
      AdditionalBankDetails: textAreaBankDetails
    },
    ibanValidationTimeout: null
  }),
  methods: {
    clearIbanTimeout() {
      if (this.ibanValidationTimeout) {
        clearTimeout(this.ibanValidationTimeout);
      }
    },
    onIbanBlur({ propertyName }, value) {
      this.clearIbanTimeout();
      this.setValue({ propertyName }, value);
    },
    onIbanInput({ propertyName }, value) {
      this.clearIbanTimeout();

      this.setValue({ propertyName }, value.toUpperCase());

      this.ibanValidationTimeout = setTimeout(
        () => this.setValue({ propertyName }, value.toUpperCase()),
        5000
      );
    }
  }
};
</script>

<style></style>
